// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperModal-cls1_c8b","cls2":"MultiPaperModal-cls2_qcB MultiPaperModal-cls1_c8b"};